// extracted by mini-css-extract-plugin
module.exports = {"container":"ffiXZCMlcr4q5kkeVFPH4","card":"_3Tm23CF1oWUkxbJXN87GXz"};